export function format(email: string) {
  if (!email) {
    return '';
  }
  return email.replace(/\+/gi, '%20');
}
